import './style.css';

export default class DiscoverNewsEventsHeader {
  static selector = ".discover-news-events-header";

  constructor(block) {
    this.block = block;
  }

  // Public methods
  onResize() {}
  onScroll() {}
}
